import router from "@/router";

export class BreadcrumbUtil {
    /**
     * This function will find tag name of branches from branch id for generate path to redirect.
     * @param items: Array
     * @param branchId: Number
     * @param branchName: String
     * @param allBranches: Array<Branches>
     * @param lang: String
     * @return items: Array
     */
    static setServiceItem(items, branchId, branchName, allBranches, lang) {
        items[0].text = branchName;
        let branch = `all`;
        for (const b of allBranches) {
            if (branchId === b.branch_id) {
                branch = b.tag_name;
                break;
            }
        }
        for (const item of items) {
            if(!!item.to || !!item.href) {
                const redirect = item.to || item.href;
                let routeTo = redirect.split(`/`);
                if (redirect.includes('home')) {
                    routeTo[2] = branch
                } else if (redirect.includes('/our-service')) {
                    // do nothing
                } else {
                    routeTo[1] = branch
                }
                if (routeTo[1] === lang) {
                    routeTo.pop()
                    item.to = '/' + routeTo[1] + '/home/' + routeTo[2]
                    item.href = '/' + routeTo[1] + '/home/' + routeTo[2]
                    // console.log(item.to)
                } else {
                    // 02/08/64 fixes page not found on breadcrumb news page to about page
                    if (redirect.substr(-6, 6) === '/about' || redirect.substr(-7, 7) === '/about/') {
                        if (routeTo[2] !== 'about') {
                            routeTo[2] = ''
                        }
                    }
                    let result = routeTo.join(`/`)
                    result = result.replace('//', '/')

                    // fix for venue hire page
                    if (router.currentRoute.name === 'VentureHireService' && result.split('/').length > 3) {
                        result = result.split('/')
                        result = result.filter((x, i) => i !== 2)
                        result = result.join('/')
                    }
                    item.to = `/${lang}` + result
                    item.href = `/${lang}` + result
                    // console.log(item.to)
                }
            }
        }
        if (router.currentRoute.name === 'EventBranch' || router.currentRoute.name === 'EventMain') {
            items[0].disabled = true
        }
        return items
    }
}
